<template>
  <div>
    <NavigationTop
      full-width
      title="Summary"
      canceltext="Back"
      cancelurl="bank-details"
    />

    <div>
      <FormSummary
        class="mb-8"
        :title="categoryTitle"
        :form="form.claim"
        :supporting-documents="form.supportingDocuments"
      />

      <CompensationSummary
        class="mb-8"
        title="Compensations"
        :form="compensations"
      />

      <FormSummary class="mb-8" title="Bank Details" :form="form.bankDetails" />

      <Consents
        :first-consent="firstConsent"
        :second-consent="secondConsent"
        @first="firstConsent = $event"
        @second="secondConsent = $event"
      />
    </div>

    <div class="flex flex-col w-1/2 mb-16 print:hidden">
      <hr class="mt-4 mb-4 border-t border-gray-400 w-full" />

      <div>
        <BaseContextualErrorMessage class="mb-4" :message="error" />
        <MainButton
          :disabled="!firstConsent || !secondConsent || submitting"
          :title="'Submit'"
          purple
          medium
          shadow
          @click="submitClaim()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import NavigationTop from '@/components/Common/Navigation/NavigationButtons/NavigationTop.vue';
import FormSummary from '@/components/Summary/FormSummary.vue';
import CompensationSummary from '@/components/Summary/CompensationSummary.vue';
import Consents from '@/components/Summary/Consents.vue';

export default {
  name: 'Summary',
  components: {
    NavigationTop,
    FormSummary,
    CompensationSummary,
    Consents
  },
  data: () => ({
    firstConsent: false,
    secondConsent: false,
    submitting: false,
    error: ''
  }),
  computed: {
    ...mapState({
      category: (state) => state.claim.category,
      compensations: (state) => state.compensations.compensations,
      claimId: (state) => state.claim.id,
      form: (state) => ({
        claim: state.form.claim,
        compensation: state.form.compensation,
        bankDetails: state.form.bankDetails,
        supportingDocuments: state.documents.documents.filter(
          (d) => d.description === 'SupportingDocument'
        )
      })
    }),
    ...mapGetters(['categoryTitle'])
  },
  mounted() {
    this.$store.commit('SET_PROGRESS', 'summary');
  },
  methods: {
    submitClaim() {
      const { commit, dispatch } = this.$store;

      this.error = '';
      this.submitting = true;

      commit('SET_SPINNER', true);

      dispatch('SUBMIT_CLAIM', { id: this.claimId })
        .then(() => {
          this.$router.push('thank-you');
          this.scrollToTop();
        })
        .catch(() => {
          this.error =
            'An unexpected error occurred while submitting your claim. Please try again later or contact us at claims@erikainsurance.com';
        })
        .finally(() => {
          commit('SET_SPINNER', false);
          this.submitting = false;
        });
    }
  }
};
</script>
